import { type ClipSpriteSheet } from '@air/api/types';

/**
 * Gets the aspect ratio of the spritesheet based on the width and height
 * @param spritesheet
 * @returns the aspect ratio of the sprite sheet
 */
export const getClipSpritesheetAspectRatio = (spritesheet: ClipSpriteSheet | undefined) => {
  if (!spritesheet) {
    return 0;
  }

  return spritesheet.aspectRatio.width / spritesheet.aspectRatio.height;
};
